import { api } from './client';

export interface ContactType {
  id: string;
  companyId: string;
  code: string;
  name: string;
  requiresSchedule: boolean;
  triggersRejection: boolean;
  isNoAnswer: boolean;
  isActive: boolean;
  sortOrder: number;
  sitesCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface ContactTypeForSite {
  id: string;
  code: string;
  name: string;
  requiresSchedule: boolean;
  triggersRejection: boolean;
  isNoAnswer: boolean;
}

export interface ContactTypeSiteAssignment {
  id: string;
  code: string;
  name: string;
  isAssigned: boolean;
}

export interface CreateContactTypeRequest {
  code: string;
  name: string;
  requiresSchedule?: boolean;
  triggersRejection?: boolean;
  isNoAnswer?: boolean;
  isActive?: boolean;
  sortOrder?: number;
}

export interface UpdateContactTypeRequest {
  code?: string;
  name?: string;
  requiresSchedule?: boolean;
  triggersRejection?: boolean;
  isNoAnswer?: boolean;
  isActive?: boolean;
  sortOrder?: number;
}

export const contactTypesApi = {
  getAll: (includeInactive = false): Promise<ContactType[]> =>
    api.get(`/contact-types${includeInactive ? '?includeInactive=true' : ''}`),

  getForSite: (): Promise<ContactTypeForSite[]> =>
    api.get('/contact-types/for-site'),

  getSiteAssignments: (id: string): Promise<ContactTypeSiteAssignment[]> =>
    api.get(`/contact-types/${id}/sites`),

  updateSiteAssignments: (id: string, siteIds: string[]): Promise<ContactTypeSiteAssignment[]> =>
    api.put(`/contact-types/${id}/sites`, { siteIds }),

  getAssignedTypeIds: (siteId: string): Promise<string[]> =>
    api.get(`/contact-types/site-types/${siteId}`),

  bulkAssignToSite: (siteId: string, contactTypeIds: string[]): Promise<void> =>
    api.put(`/contact-types/site-types/${siteId}`, { siteIds: contactTypeIds }),

  create: (data: CreateContactTypeRequest): Promise<ContactType> =>
    api.post('/contact-types', data),

  update: (id: string, data: UpdateContactTypeRequest): Promise<ContactType> =>
    api.patch(`/contact-types/${id}`, data),

  deactivate: (id: string): Promise<ContactType> =>
    api.delete(`/contact-types/${id}`),

  reactivate: (id: string): Promise<ContactType> =>
    api.patch(`/contact-types/${id}/reactivate`, {}),
};
